export default __webpack_public_path__ + "static/media/element_34.6d7f82dc.avif";